import type {NotificationBell} from "../../src/components/notification-bell/notification-bell";

import {html} from "lit";
import type {Meta, StoryObj} from "@storybook/web-components";

const meta: Meta<NotificationBell> = {
	title: "Notification/Notification Bell",
	component: "uxn-notification-bell",

	render: ({connectionTimeout}) => html`<uxn-notification-bell connection-timeout="${connectionTimeout}" />`,

	argTypes: {
		connectionTimeout: {control: "number"},
		// counter: {control: "range", min: 0, max: 100, step: 1},
	},
};

export default meta;
type Story = StoryObj<NotificationBell>;

export const Default: Story = {
	args: {
		connectionTimeout: 5555,
		// counter: 42,
	},
	parameters: {
		controls: {exclude: ["connectError"]}, // hide internal variables
	},
};

export const NoNotifications: Story = {
	parameters: {
		controls: {include: []},
	},
	args: {
		...Default.args,
		// counter: 0,
	},
};

export const MaxNotifications: Story = {
	parameters: {
		controls: {include: []},
	},
	args: {
		...Default.args,
		// counter: 100,
	},
};
